<template>
  <el-container class="layout-container">
    <!-- Sidebar -->
    <el-aside :width="isCollapse ? '64px' : '220px'" class="sidebar">
      <div class="logo">
        <img src="" alt="" style="display:none" />
        <span v-if="!isCollapse" class="logo-text">锦鲤在线</span>
        <span v-else class="logo-text-mini">锦鲤</span>
      </div>
      <div class="sidebar-menu-wrapper">
        <el-menu
          ref="sidebarMenu"
          :default-active="activeMenu"
          :default-openeds="defaultOpeneds"
          :collapse="isCollapse"
          background-color="#304156"
          text-color="#bfcbd9"
          active-text-color="#409EFF"
          :router="true"
          class="sidebar-menu"
        >
          <template v-for="item in menuItems">
            <el-submenu v-if="item.children" :key="item.index" :index="item.index">
              <template slot="title">
                <i :class="item.icon"></i>
                <span>{{ item.title }}</span>
              </template>
              <el-menu-item
                v-for="child in item.children"
                :key="child.path"
                :index="child.path"
              >
                <i :class="child.icon"></i>
                <span slot="title">{{ child.title }}</span>
              </el-menu-item>
            </el-submenu>
            <el-menu-item v-else :key="item.path" :index="item.path">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.title }}</span>
            </el-menu-item>
          </template>

          <el-submenu index="course-group">
            <template slot="title">
              <i class="el-icon-goods"></i>
              <span>课程管理</span>
            </template>
            <el-menu-item
              v-for="item in courseMenuItems"
              :key="item.path"
              :index="item.path"
            >
              <i :class="item.icon"></i>
              <span slot="title">{{ item.title }}</span>
            </el-menu-item>
          </el-submenu>

          <el-submenu index="config-group">
            <template slot="title">
              <i class="el-icon-setting"></i>
              <span>配置管理</span>
            </template>
            <el-menu-item
              v-for="item in configMenuItems"
              :key="item.path"
              :index="item.path"
            >
              <i :class="item.icon"></i>
              <span slot="title">{{ item.title }}</span>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </el-aside>

    <!-- Main area -->
    <el-container class="main-container">
      <!-- Header -->
      <el-header class="header">
        <div class="header-left">
          <i
            :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
            class="collapse-btn"
            @click="toggleCollapse"
          ></i>
        </div>
        <div class="header-right">
          <span class="admin-name">
            <i class="el-icon-user-solid"></i>
            {{ adminName }}
          </span>
          <el-button type="text" class="logout-btn" @click="handleLogout">
            <i class="el-icon-switch-button"></i> 退出登录
          </el-button>
        </div>
      </el-header>

      <!-- Content -->
      <el-main class="main-content">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: 'Layout',

  data() {
    return {
      isCollapse: false,
      menuItems: [
        { path: '/dashboard', title: '仪表盘', icon: 'el-icon-s-home' },
        { path: '/users', title: '用户管理', icon: 'el-icon-user' },
        {
          index: 'teacher-group',
          title: '教师管理',
          icon: 'el-icon-s-custom',
          children: [
            { path: '/teachers', title: '老师管理', icon: 'el-icon-s-custom' },
            { path: '/assistants', title: '助教管理', icon: 'el-icon-user' }
          ]
        },
        {
          index: 'booking-group',
          title: '预约管理',
          icon: 'el-icon-date',
          children: [
            { path: '/trial-bookings', title: '试听预约', icon: 'el-icon-date' },
            { path: '/formal-bookings', title: '正课预约', icon: 'el-icon-s-order' }
          ]
        },
        {
          index: 'class-hour-group',
          title: '课时管理',
          icon: 'el-icon-time',
          children: [
            { path: '/formal-class-hours', title: '正式课时', icon: 'el-icon-notebook-2' },
            { path: '/trials', title: '试听权限', icon: 'el-icon-video-play' }
          ]
        },
        {
          index: 'order-group',
          title: '订单管理',
          icon: 'el-icon-s-order',
          children: [
            { path: '/orders', title: '订单管理', icon: 'el-icon-s-order' },
            { path: '/refunds', title: '退款管理', icon: 'el-icon-money' }
          ]
        },
        {
          index: 'agent-group',
          title: '代理管理',
          icon: 'el-icon-s-cooperation',
          children: [
            { path: '/agents', title: '代理管理', icon: 'el-icon-s-cooperation' },
            { path: '/commissions', title: '佣金管理', icon: 'el-icon-coin' },
            { path: '/withdrawals', title: '提现管理', icon: 'el-icon-wallet' },
            { path: '/agent-materials', title: '物料管理', icon: 'el-icon-folder-opened' }
          ]
        },
        { path: '/replays', title: '回放管理', icon: 'el-icon-film' },
        {
          index: 'log-group',
          title: '日志管理',
          icon: 'el-icon-document',
          children: [
            { path: '/logs', title: '操作日志', icon: 'el-icon-document' }
          ]
        }
      ],
      courseMenuItems: [
        { path: '/courses/levels', title: '课程套餐', icon: 'el-icon-goods' },
        { path: '/courses/homepage-teachers', title: '首页教师', icon: 'el-icon-user' }
      ],
      configMenuItems: [
        { path: '/config/ad-banners', title: '广告位管理', icon: 'el-icon-picture' },
        { path: '/config/scroll-messages', title: '滚动消息管理', icon: 'el-icon-bell' },
        { path: '/config/subjects', title: '科目管理', icon: 'el-icon-notebook-2' },
        { path: '/config/grades', title: '年级管理', icon: 'el-icon-school' },
        { path: '/config/schools', title: '学校管理', icon: 'el-icon-office-building' },
        { path: '/config/grade-subject', title: '年级科目关联', icon: 'el-icon-link' },
        { path: '/config/time-slots', title: '时间段管理', icon: 'el-icon-time' },
        { path: '/config/trial-benefits', title: '试听权益管理', icon: 'el-icon-present' },
        { path: '/config/home-texts', title: '首页文案管理', icon: 'el-icon-document' },
        { path: '/config/site-config', title: '通用配置', icon: 'el-icon-tools' },
        { path: '/config/customer-service', title: '客服配置', icon: 'el-icon-service' },
        { path: '/config/consultations', title: '在线咨询', icon: 'el-icon-chat-line-square' }
      ]
    }
  },

  computed: {
    activeMenu() {
      if (this.$route.path.startsWith('/replays')) {
        return '/replays'
      }
      if (this.$route.path.startsWith('/courses')) {
        return this.$route.path
      }
      if (
        this.$route.path.startsWith('/trial-bookings') ||
        this.$route.path.startsWith('/formal-bookings') ||
        this.$route.path.startsWith('/formal-class-hours') ||
        this.$route.path.startsWith('/trials')
      ) {
        return this.$route.path
      }
      return this.$route.path
    },
    defaultOpeneds() {
      const openeds = []
      if (this.$route.path.startsWith('/teachers') || this.$route.path.startsWith('/assistants')) {
        openeds.push('teacher-group')
      }
      if (this.$route.path.startsWith('/config')) openeds.push('config-group')
      if (this.$route.path.startsWith('/courses')) openeds.push('course-group')
      if (this.$route.path.startsWith('/trial-bookings')
        || this.$route.path.startsWith('/formal-bookings')) {
        openeds.push('booking-group')
      }
      if (this.$route.path.startsWith('/formal-class-hours') || this.$route.path.startsWith('/trials')) {
        openeds.push('class-hour-group')
      }
      if (this.$route.path.startsWith('/orders') || this.$route.path.startsWith('/refunds')) {
        openeds.push('order-group')
      }
      if (
        this.$route.path.startsWith('/agents') ||
        this.$route.path.startsWith('/commissions') ||
        this.$route.path.startsWith('/withdrawals') ||
        this.$route.path.startsWith('/agent-materials')
      ) {
        openeds.push('agent-group')
      }
      if (this.$route.path.startsWith('/logs')) {
        openeds.push('log-group')
      }
      return openeds
    },
    adminName() {
      const user = this.$store.state.userInfo
      return (user && (user.name || user.phone)) || '管理员'
    }
  },

  watch: {
    '$route.path': {
      immediate: true,
      handler(path) {
        if (path.startsWith('/teachers') || path.startsWith('/assistants')) {
          this.$nextTick(() => {
            if (this.$refs.sidebarMenu) this.$refs.sidebarMenu.open('teacher-group')
          })
        }
      }
    }
  },

  methods: {
    toggleCollapse() {
      this.isCollapse = !this.isCollapse
    },

    handleLogout() {
      this.$confirm('确认退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('logout')
        this.$router.push('/login')
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.layout-container {
  height: 100vh;
}

.sidebar {
  background-color: #304156;
  transition: width 0.3s;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.logo {
  height: 60px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #263445;
}

.sidebar-menu-wrapper {
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
}

.sidebar-menu-wrapper::-webkit-scrollbar {
  width: 6px;
}

.sidebar-menu-wrapper::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.sidebar-menu-wrapper::-webkit-scrollbar-track {
  background: transparent;
}

.logo-text {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  white-space: nowrap;
}

.logo-text-mini {
  color: #fff;
  font-size: 14px;
  font-weight: bold;
}

.sidebar-menu {
  border-right: none;
}

.sidebar-menu:not(.el-menu--collapse) {
  width: 220px;
}

.main-container {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.header {
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  z-index: 1;
}

.header-left {
  display: flex;
  align-items: center;
}

.collapse-btn {
  font-size: 20px;
  cursor: pointer;
  color: #606266;
  transition: color 0.3s;
}

.collapse-btn:hover {
  color: #409EFF;
}

.header-right {
  display: flex;
  align-items: center;
}

.admin-name {
  margin-right: 20px;
  color: #606266;
  font-size: 14px;
}

.admin-name i {
  margin-right: 5px;
}

.logout-btn {
  color: #909399;
  font-size: 14px;
}

.logout-btn:hover {
  color: #F56C6C;
}

.main-content {
  background-color: #f0f2f5;
  padding: 20px;
  overflow-y: auto;
  flex: 1;
}
</style>
